/*! Copyright (c) Safe As Milk. All rights reserved. */
import DetailsDisclosure from "details-disclosure";

class HeaderDetailsDisclosure extends DetailsDisclosure {
    #boundMouseEnterListener;
    #boundMouseLeaveListener;
    constructor() {
        super();
        this.#boundMouseEnterListener = this.mouseEnterListener.bind(this);
        this.#boundMouseLeaveListener = this.mouseLeaveListener.bind(this);
    }
    connectedCallback() {
        super.connectedCallback();
        const toggleTarget = this.trigger || this.mainDetailsToggle;
        if (toggleTarget) {
            toggleTarget.addEventListener("pointerenter", this.#boundMouseEnterListener);
            toggleTarget.addEventListener("pointerleave", this.#boundMouseLeaveListener);
        }
    }
    disconnectedCallback() {
        this.disableListeners();
    }
    open() {
        if (this.isOpen) return;
        super.open();
        if (this.content && this.content.getBoundingClientRect().x + this.content.offsetWidth > window.innerWidth - 30) {
            this.content.classList.add("is-left-aligned");
        }
        if (this.hasAttribute("adjust-mega-menu-height")) this.#setContentHeight(36);
        this.handleMenuOpenState(true);
    }
    close() {
        if (!this.isOpen) return;
        super.close();
        if (this.content) this.content.classList.remove("is-left-aligned");
        if (this.hasAttribute("adjust-mega-menu-height")) this.#removeContentHeight();
        this.handleMenuOpenState(false);
    }
    handleMenuOpenState(isOpen) {
        if (isOpen) {
            document.body.setAttribute("header-menu-open", "");
            if (this.classList.contains("mega")) {
                document.body.setAttribute("header-mega-menu-open", "");
            }
        } else {
            document.body.removeAttribute("header-menu-open");
            if (this.classList.contains("mega")) {
                document.body.removeAttribute("header-mega-menu-open");
            }
        }
    }
    mouseEnterListener(e) {
        if (e && e.pointerType === "touch") return;
        if (!document.querySelector("body").hasAttribute("header-details-disclosure-edit")) this.open();
    }
    mouseLeaveListener(e) {
        if (e && e.pointerType === "touch") return;
        if (!document.querySelector("body").hasAttribute("header-details-disclosure-edit")) this.close();
    }
    disableListeners() {
        const toggleTarget = this.trigger || this.mainDetailsToggle;
        if (toggleTarget) {
            toggleTarget.removeEventListener("pointerenter", this.#boundMouseEnterListener);
            toggleTarget.removeEventListener("pointerleave", this.#boundMouseLeaveListener);
        }
    }
    #setContentHeight(padding = 0) {
        const headerSection = document.querySelector(".js-header");
        const headerBottomBoundary = headerSection && headerSection.getBoundingClientRect().bottom > 0 ? headerSection.getBoundingClientRect().bottom : 0;
        const combinedPanelCutoff = Math.round(headerBottomBoundary + padding);
        if (this.content && this.content.offsetHeight > window.innerHeight - combinedPanelCutoff) {
            this.content.style.setProperty("--header-elements-height", `${combinedPanelCutoff}px`);
            this.content.classList.add("has-height-control");
        }
    }
    #removeContentHeight() {
        if (this.content) this.content.classList.remove("has-height-control");
    }
}

customElements.define("header-details-disclosure", HeaderDetailsDisclosure);
//# sourceMappingURL=header-details-disclosure.js.map
